import React, {useEffect, useState} from 'react';
import '@components/product/product.scss';
import {ClaimedStatusType, IREACT_SELECT, USER_ACTION, VerificationType} from '@src/types';
import failedIcon from '@assets/images/icons/fail.svg';
import warningIcon from '@assets/images/icons/warning.svg';
import verifiedIcon from '@assets/images/icons/verify.svg';
import chatIcon from '@assets/images/icons/chat.svg';
import openLinkIcon from '@assets/images/icons/readmore-blue.svg';
import powerByImg from '@assets/images/power-by.png';
import {useSelector} from 'react-redux';
import {translate} from '@src/helpers';
import _ from "lodash-es";
import {DEFAULT_SELECT} from "@src/variables";
import {Swiper, SwiperSlide} from 'swiper/react';
import {Autoplay, Navigation, Pagination} from "swiper";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import {faInfoCircle} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {OverlayTrigger, Tooltip} from "react-bootstrap";

interface IProductProps {
  image: string,
  product_images: Array<any>
  message: string,
  status: VerificationType,
  name: string,
  company: string,
  companyUrl?: string,
  desc: string,
  companyPhone?: string,
  companyEmail?: string,
  id?: string
  attributeTemplateValue?: any
  claimed_status: ClaimedStatusType,
}

const mappingIcon = {
  [VerificationType.FAILED]: failedIcon,
  [VerificationType.WARNING]: warningIcon,
  [VerificationType.VERIFIED]: verifiedIcon,
}

const mappingTitle = {
  [ClaimedStatusType.SELF_REPORTED]: 'B2C.VERIFY.SELF_REPORTED',
  [ClaimedStatusType.MAPPED]: 'B2C.VERIFY.MAPPED',
  [ClaimedStatusType.VERIFIED]: 'B2C.VERIFY.VERIFIED',
}

const checkIcon = () => {
  return <span className={"mr-1"}>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
             fill="none"
             style={{clipPath: "url(#clip0_2_654)"}}>
        <g>
            <path
              d="M11.0597 5.0535L6.66634 9.44683L4.27301 7.06016L3.33301 8.00016L6.66634 11.3335L11.9997 6.00016L11.0597 5.0535ZM7.99967 1.3335C4.31967 1.3335 1.33301 4.32016 1.33301 8.00016C1.33301 11.6802 4.31967 14.6668 7.99967 14.6668C11.6797 14.6668 14.6663 11.6802 14.6663 8.00016C14.6663 4.32016 11.6797 1.3335 7.99967 1.3335ZM7.99967 13.3335C5.05301 13.3335 2.66634 10.9468 2.66634 8.00016C2.66634 5.0535 5.05301 2.66683 7.99967 2.66683C10.9463 2.66683 13.333 5.0535 13.333 8.00016C13.333 10.9468 10.9463 13.3335 7.99967 13.3335Z"
              fill="#525252"/>
        </g>
        <defs>
            <clipPath id="clip0_2_654">
                <rect width="16" height="16" fill="white"/>
            </clipPath>
        </defs>
    </svg></span>
}

const getFibreStatus = (status: ClaimedStatusType) => {
  let badgeClassName = "";
  let icon;
  switch (status) {
    case ClaimedStatusType.MAPPED:
      badgeClassName = "fib-claimed-badge"
      icon = checkIcon()
      break;
    case ClaimedStatusType.SELF_REPORTED:
      badgeClassName = "fib-unclaimed-badge"
      icon = <FontAwesomeIcon icon={faInfoCircle} className={`mr-1`}/>
      break;
    case ClaimedStatusType.VERIFIED:
      badgeClassName = "fib-verified-badge"
      icon = checkIcon()
      break;
  }
  return {badgeClassName, icon};
}

const Product = ({
                   image,
                   product_images,
                   status,
                   claimed_status,
                   message,
                   name,
                   company,
                   companyUrl,
                   desc,
                   companyPhone,
                   companyEmail,
                   id,
                   attributeTemplateValue
                 }: IProductProps) => {

  const [templates, setTemplates] = useState({...DEFAULT_SELECT})

  const [questions, setQuestions] = useState({
    selected: [],
    list: [],
  } as any);

  const langData = useSelector((state: any) => state.currentLanguage) as any;

  const fibreStatus = getFibreStatus(claimed_status);

  const productTemplateHandle = {
    getBatch: async (extra = {}) => {
      let tp = {...templates};

      try {
        /**
         * Handle logic to fetch templateList here
         */
        return tp;
      } catch (e) {
        console.error(e)
        return tp;
      }
    },
    getCurrentTemplates: async (data: any) => {
      try {
        let tp = {...templates}, q = {...questions};
        let {attributeTemplateValue} = data;

        if (_.isArray(attributeTemplateValue) && !_.isEmpty(attributeTemplateValue)) {
          setQuestions({...questions, list: [...attributeTemplateValue]})
          return attributeTemplateValue;
        }
      } catch (e) {
        console.error(e)
      }
    },

  }

  const fibreStatusBadge = () => {
    return <span className={fibreStatus.badgeClassName}>
                            {fibreStatus.icon}
      {translate(langData.localize, mappingTitle[claimed_status])}
                </span>
  }

  useEffect(() => {
    (async () => {
      let tpl: IREACT_SELECT = await productTemplateHandle.getBatch()

      await productTemplateHandle.getCurrentTemplates({attributeTemplateValue});

      if (_.isArray(attributeTemplateValue) && !_.isEmpty(attributeTemplateValue)) {
        if (!_.isEmpty(tpl.list)) {
          tpl.selected = attributeTemplateValue.map((v: any) => {
            let {uid, name} = v;
            return {...v, value: uid, label: name}
          })
          setTemplates({
            ...templates, ...tpl
          });
        }
      }
    })();
  }, [])

  return (
    <div className="product" id={id}>
      <div className="product_image" style={{overflow: "hidden"}}>
        {/*<img src={image} alt="Product Image"/>*/}

        <Swiper
          className={`fib-swiper`}
          pagination={{
            clickable: true,
            dynamicBullets: true,
          }}
          autoplay={{
            delay: 5000,
            disableOnInteraction: true,
          }}
          navigation={true}
          loop={true}
          modules={[Pagination, Autoplay, Navigation]}
          breakpoints={{
            640: {
              slidesPerView: 1,
              spaceBetween: 0,
            },
            768: {
              slidesPerView: 1,
              spaceBetween: 0,
            },
            1024: {
              slidesPerView: 1,
              spaceBetween: 0,
            },
          }}
          // onSlideChange={() => console.log('slide change')}
          // onSwiper={(swiper) => console.log(swiper)}
        >
          {
            _.map(product_images, (p: any) => {
              return (
                <SwiperSlide key={_.uniqueId(`product_image_`)}>
                  <img src={p?.sizes?.large || image}
                       alt={`Product Image ${p?.id}`}
                  />
                </SwiperSlide>
              )
            })
          }

        </Swiper>

      </div>
      <div className="pcard">


        <div className="pcard_body">
          <h4 className="product_name fz-20 lh-28">{name}</h4>
          <div className="product_by">
            <span className={""}>by</span> <strong className={""}>{company}</strong>
            {companyUrl && <a href={companyUrl}><img src={openLinkIcon} alt=""/></a>}
          </div>

          <div className={"mt-3"}>
            {
              status === VerificationType.VERIFIED
                ? fibreStatusBadge()
                : <OverlayTrigger overlay={

                  <Tooltip id={`product-tooltip`}>
                    {translate(langData.localize, `B2C.VERIFY_DESC.${status}`)}
                  </Tooltip>}>

                  {fibreStatusBadge()}
                </OverlayTrigger>
            }

          </div>

          <div className="product_desc" dangerouslySetInnerHTML={{__html: desc}}/>
          {
            (companyPhone || companyEmail) &&
              <div className="product_contact">
                {companyEmail && <a href={`mailto:${companyEmail}`}><img src={chatIcon} alt=""/></a>}
              </div>
          }

        </div>

        <div className="pcard_power">
          <img src={powerByImg} alt=""/>
        </div>

      </div>
    </div>
  );
}

export default Product;
